module.exports = __webpack_public_path__ + "static/img/course-pic.d99e08c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/data-base/course-pic.jpg
// module id = KEpC
// module chunks = 1